// apex.ts
import { Apex } from "@maersk-global/apex-client";

export const apex = new Apex({
  // ApexSetupOptions: Optional setup parameter
  templatedExperimentsEnabled: true
});
